// Dashboard Map

// Default
import React, { useEffect, useState } from "react";
import markersData from "../../json/Meter.json";

// Custom
import Dashboard360Map from "../map/Dashboard360Map";

// Mui
import Grid from "@mui/material/Grid2";
import useMediaQuery from "@mui/material/useMediaQuery";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Svg
import Menu from "../../assets/svg/menu";
import DoubleMeter from "../../assets/svg/doubleMeter";
import Power from "../../assets/svg/power";
import Meter1 from "../../assets/svg/meter1";
import Failure from "../../assets/svg/failure";

// Theme
import theme from "../../theme";

const DashboardMap: React.FC = () => {
  const matches = useMediaQuery(theme.breakpoints.down("lg"));

  const [markers, setMarkers] = useState<any[]>([]);
  const [status, setStatus] = useState("all");

  useEffect(() => {
    if (status === "all") {
      setMarkers(markersData.markers);
    } else if (status === "failure") {
      const sliceData = markersData.markers.slice(0, 15);
      setMarkers(sliceData);
    } else {
      const filterData = markersData.markers.filter(
        (item) => item.status === status
      );
      setMarkers(filterData);
    }
  }, [status]);

  const MAP_CONTENT_DATA = [
    {
      icon: <DoubleMeter />,
      title: "10,000",
      subTitle: "Total Meters",
      status: "all",
    },
    {
      icon: <Meter1 />,
      title: "9,500",
      subTitle: "Active Meters",
      status: "active",
    },
    {
      icon: <Meter1 fill="#FF3B30" />,
      title: "500",
      subTitle: "Inactive Meters",
      status: "inactive",
    },
    {
      icon: <Failure />,
      title: "20",
      subTitle: "Communication Failure",
      status: "failure",
    },
  ];
  return (
    <Card className="dashboard_map">
      <Grid container spacing={matches ? 1 : 2.25}>
        <Grid size={{ xs: 12, md: 9.35, lg: 9.35 }}>
          <Card className="dashboard_map_left_card">
            <Dashboard360Map
              filteredMarkers={markers}
              setMarkers={setMarkers}
              setStatus={setStatus}
            />
          </Card>
        </Grid>

        <Grid
          size={{ xs: 12, md: 2.65, lg: 2.65 }}
          className="dashboard_map_content_card"
        >
          {/* <Stack direction={"row"} justifyContent={"flex-end"} mb={"35px"}>
            <Menu />
          </Stack> */}

          {MAP_CONTENT_DATA.map((item, index) => {
            return (
              <Box
                className="dashboard_map_content_card_box"
                p={"7px 0"}
                onClick={() => {
                  setStatus(item.status);
                }}
                key={index}
              >
                <Stack
                  direction={"row"}
                  gap={"20px"}
                  alignItems={"center"}
                  height={"75px"}
                  borderRadius={"5px"}
                  px={"10px"}
                  sx={{
                    backgroundColor:
                      item.status === status ? "#DCEEFF" : "transparent",
                  }}
                >
                  <Box>{item.icon}</Box>
                  <Box>
                    <Typography
                      variant="body1"
                      fontSize={"23px"}
                      lineHeight={"30px"}
                      fontWeight={600}
                      color={item.status === status ? "#1064ED" : "#000000"}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontSize={"15px"}
                      color={item.status === status ? "#1064ED" : "#000000"}
                      mt={"5px"}
                    >
                      {item.subTitle}
                    </Typography>
                  </Box>
                </Stack>
              </Box>
            );
          })}

          <Box className="dashboard_map_content_card_box" p={"7px 0"}>
            <Stack
              direction={"row"}
              gap={"20px"}
              alignItems={"center"}
              height={"75px"}
              borderRadius={"5px"}
              px={"10px"}
            >
              <Box>
                <Power fill="#FF7700" />
              </Box>
              <Box>
                <Typography
                  variant="body1"
                  fontSize={"23px"}
                  fontWeight={600}
                  lineHeight={"30px"}
                  color="#000000"
                >
                  150,000 <span style={{ fontSize: "15px" }}>kwh</span>
                </Typography>
                <Typography variant="body1" color="#000000" fontSize={"15px"}>
                  Total Energy Consumption <br />{" "}
                  <span style={{ fontSize: "13px" }}>(Last 24 hours)</span>
                </Typography>
              </Box>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};

export default DashboardMap;
